"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _add = _interopRequireDefault(require("@atlaskit/icon/core/add"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EditorAddIcon = props => /*#__PURE__*/_react.default.createElement(_base.UNSAFE_IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V7a1 1 0 0 0-2 0v4H7a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 0-2z"/></svg>`
}, props, {
  newIcon: _add.default
}));
EditorAddIcon.displayName = 'EditorAddIcon';
var _default = exports.default = EditorAddIcon;